import { render, staticRenderFns } from "./ProductsOverviewPage.vue?vue&type=template&id=d043bcc0&"
import script from "./ProductsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./ProductsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsOverviewPage.vue?vue&type=style&index=0&id=d043bcc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports